var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineKeyboardOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.27 19.59c-.79 0-1.36-.03-1.85-.1-3.47-.38-4.16-2.46-4.16-5.91V7.26c0-3.45.68-5.53 4.18-5.91.48-.07 1.05-.1 1.83-.1h9.47c.78 0 1.35.03 1.85.1 3.48.38 4.16 2.46 4.16 5.91v6.32c0 3.45-.68 5.53-4.18 5.91-.47.07-1.04.1-1.83.1H7.27zM5.62 2.84c-2.16.24-2.87.91-2.87 4.43v6.32c0 3.51.71 4.19 2.85 4.42.44.06.95.09 1.67.09h9.47c.72 0 1.22-.03 1.64-.09 2.16-.24 2.87-.91 2.87-4.43V7.26c0-3.51-.71-4.19-2.85-4.42-.45-.06-.95-.09-1.67-.09H7.26c-.71 0-1.22.03-1.64.09z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.58 9.07c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h3.68a.749.749 0 1 1 0 1.5h-3.68zM9 8.32c0-.55.44-1 1-1 .55 0 1 .45 1 1s-.44 1-1 1c-.55 0-1-.45-1-1zM5.85 8.32c0-.55.44-1 1-1h.01c.55 0 1 .45 1 1s-.46 1-1.01 1-1-.45-1-1zM6.75 14.86c-.41 0-.76-.34-.76-.75s.33-.75.74-.75h10.53a.749.749 0 1 1 0 1.5H6.75zM7 22.75c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h10c.41 0 .75.34.75.75s-.34.75-.75.75H7z",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineKeyboardOpen);
export default __webpack_public_path__ + "static/media/vuesax-outline-keyboard-open.5e8056e817d38fd6b58fd55663b1d8a8.svg";
export { ForwardRef as ReactComponent };